/** @format */

import React, { useState } from "react";
import { FiMenu } from "react-icons/fi";
import { AiOutlineCloseCircle } from "react-icons/ai";
import { Logo } from "./landing/Logo";
import NavBarLinks from "./landing/NavBarLinks";
import SignUpButton from "./landing/SignUpButton";

const Navbar = () => {
  const [show, setShow] = useState(false);
  const navLinks = [
    { title: "Home", link: "#hero", onClick: () => setShow(false) },
    { title: "About", link: "#hero", onClick: () => setShow(false) },
    { title: "Services", link: "#services", onClick: () => setShow(false) },
    { title: "Gallery", link: "#gallery", onClick: () => setShow(false) },
    { title: "Review", link: "#reviews", onClick: () => setShow(false) },
    { title: "Faq", link: "#faq", onClick: () => setShow(false) },
  ];

  return (
    <div className="navbar-bg">
      <div className="flex justify-between items-center xl:px-24 md:px-8 px-2">
        <a href="/">
          <Logo />
        </a>
        <div className="hidden lg:flex space-x-[37px] uppercase text-white text-[18px] leading-[24.55px] font-normal ">
          {navLinks &&
            navLinks.map((item) => (
              <NavBarLinks link={item.link} title={item.title} />
            ))}
        </div>
        <div className="flex lg:space-x-0 space-x-8">
          <div
            className="lg:hidden flex cursor-pointer"
            onClick={() => setShow(!show)}
          >
            <FiMenu size={40} color="white" />
          </div>
          <SignUpButton className="hidden md:flex " />
        </div>
      </div>
      {show && (
        <div className="h-auto w-[70%] absolute bg-purple-800 z-50 right-0 top-0">
          <div
            className="flex justify-end items-end pr-10 pt-6 cursor-pointer"
            onClick={() => setShow(false)}
          >
            <AiOutlineCloseCircle size={40} color="white" />
          </div>
          <div className="flex flex-col justify-end items-end space-y-[37px] uppercase text-white text-[18px] leading-[24.55px] font-normal pr-10 pt-10  pb-10">
            {navLinks &&
              navLinks.map((item) => (
                <NavBarLinks
                  link={item.link}
                  title={item.title}
                  onClick={item.onClick}
                />
              ))}
            <div onClick={() => setShow(false)}>
              <SignUpButton className="flex md:hidden " />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Navbar;
